import Close from "@mui/icons-material/Close";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import type { BoxProps } from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { TransitionProps } from "notistack";
import React, { forwardRef } from "react";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export type FullScreenProps = {
  title?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  expanded: boolean;
  handleClose: () => void;
} & BoxProps;

export default function FullScreen({ title, actions, children, expanded, handleClose, ...props }: FullScreenProps) {
  if (expanded) {
    return (
      <React.Fragment>
        <Dialog fullScreen open={true} onClose={handleClose} TransitionComponent={Transition}>
          <AppBar sx={{ position: "relative", height: "48px" }}>
            <Toolbar sx={{ minHeight: "48px !important", paddingLeft: "1em !important", paddingRight: "0 !important" }}>
              <Typography sx={{ flex: 1 }} variant="h6" component="div">
                {title}
              </Typography>
              {actions}
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <Close />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Box {...props}>{children}</Box>
        </Dialog>
      </React.Fragment>
    );
  }
  return <>{children}</>;
}
